<template>
  <div class="order-container">
    <div class="search-bar">
      <input type="text" placeholder="ID" v-model="searchId" />
      <input type="text" placeholder="用户：昵称/姓名" v-model="searchUsername" />
      <select v-model="searchType">
        <option value="">类型：全部</option>
        <option value="早餐">早餐</option>
        <option value="中餐">中餐</option>
        <option value="晚餐">晚餐</option>
      </select>
      <select v-model="searchStatus">
        <option value="">状态：全部</option>
        <option value="待核销">待核销</option>
        <option value="已核销">已核销</option>
      </select>
      <input type="date" v-model="searchDate" placeholder="就餐日期" />
      <button class="search-button" @click="searchOrders">搜索</button>
      <button class="clear-button" @click="clearSearch">清空</button>
    </div>
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>用户</th>
          <th>类型</th>
          <th>价格</th>
          <th>核销优惠价格</th>
          <th>就餐日期</th>
          <th>状态</th>
          <th>下单时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in filteredOrders" :key="order.id">
          <td>{{ order.id }}</td>
          <td>{{ order.name }}</td>
          <td :class="{'type-breakfast': order.leixing === '早餐', 'type-lunch': order.leixing === '午餐', 'type-dinner': order.leixing === '晚餐'}">{{ order.leixing }}</td>
          <td>{{ order.money }}</td>
          <td>{{ order.youhui }}</td>
          <td>{{ order.jiucanTime.split(' ')[0] }}</td>
          <td>
            <span class="status-dot" :class="{'status-active': order.isHexiao === 1, 'status-cancelled': order.isHexiao === 0}"></span>
            {{ order.isHexiao === 1 ? '已核销' : '待核销' }}
          </td>
          <td>{{ order.xiadanTime }}</td>
          <td>
            <button v-if="order.isHexiao === 0" @click="cancelOrder(order)">核销</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  data() {
    return {
      searchId: '',
      searchUsername: '',
      searchType: '',
      searchStatus: '',
      searchDate: '',
      orders: [],
      filteredOrders: []
    };
  },
  methods: {
    async fetchOrders() {
      try {
        const response = await this.$axios.get('/api/show_admin_dingdan');
        const data = response.data;
        if (data.code === 0) {
          this.orders = data.data.map(order => ({
            ...order,
            status: order.isHexiao === 1 ? '已核销' : '待核销'
          }));
          this.filteredOrders = this.orders; // 初始化显示所有订单
        } else {
          console.error('Failed to fetch orders:', data.message);
        }
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    },
    searchOrders() {
      this.filteredOrders = this.orders.filter(order => {
        const matchesId = this.searchId ? order.id.toString().includes(this.searchId) : true;
        const matchesUsername = this.searchUsername ? order.name.toLowerCase().includes(this.searchUsername.toLowerCase()) : true;
        const matchesType = this.searchType ? order.leixing === this.searchType : true;
        const matchesStatus = this.searchStatus ? order.status === this.searchStatus : true;
        const matchesDate = this.searchDate ? order.jiucanTime.split(' ')[0] === this.searchDate : true;
        return matchesId && matchesUsername && matchesType && matchesStatus && matchesDate;
      });
    },
    clearSearch() {
      this.searchId = '';
      this.searchUsername = '';
      this.searchType = '';
      this.searchStatus = '';
      this.searchDate = '';
      this.filteredOrders = this.orders; // 清空搜索条件后显示所有订单
    },
    async cancelOrder(order) {
      if (confirm('确定要核销这个订单吗？')) {
        try {
          const response = await this.$axios.post('/api/admin_hexiao', {
            id: order.id,
            money: order.money,
            youhui: order.youhui,
            userid: order.userid,
            leixing: order.leixing
          });
          console.log(order)
          const data = response.data;
          if (data.code === 0) {
            this.$message.success({
            message: '订单核销成功',
            duration: 2000
          });
            this.fetchOrders(); // 刷新订单列表
          } else {
            this.$message.error({
            message: '订单核销失败',
            duration: 2000
          });
          }
        } catch (error) {
          console.error('Error canceling order:', error);
        }
      }
    }
  },
  mounted() {
    this.fetchOrders();
  }
};
</script>

<style scoped>
.order-container {
  padding: 20px;
  background-color: #f5f5f5;
}

.search-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
}

.search-bar input,
.search-bar select,
.search-bar button {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

.search-button {
  background-color: #007bff;
  color: white;
}

.clear-button {
  background-color: #dc3545;
  color: white;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}

.type-breakfast {
  color: green;
}

.type-lunch {
  color: blue;
}

.type-dinner {
  color: orange;
}

.status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}

.status-active {
  background-color: green;
}

.status-cancelled {
  background-color: red;
}

button {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>